
export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/237693385267"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-40 cursor-pointer"
      aria-label="Contacter via WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  );
}
